import React from "react";
import { Plus, Star } from "lucide-react";

const fmt = (n) => n.toFixed(2).replace(".", ",") + "€";

const MenuItemCard = ({ item, onAdd }) => {
  const from = item.seul ?? item.menu;
  return (
    <div className="group bg-[#141414] rounded-2xl overflow-hidden border border-white/10 card-hover flex flex-col">
      <div className="relative h-40 overflow-hidden">
        {item.comingSoon ? (
          <div className="w-full h-full bg-black flex flex-col items-center justify-center border-b border-pink/30">
            <span className="font-display text-2xl md:text-3xl uppercase text-pink leading-none">Coming</span>
            <span className="font-display text-2xl md:text-3xl uppercase text-gold leading-none">Soon</span>
            <span className="mt-2 text-white/40 text-[9px] uppercase tracking-[0.25em]">Bientôt disponible</span>
          </div>
        ) : (
          <>
            <img
              src={item.image}
              alt={item.name}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#141414] to-transparent" />
          </>
        )}
        {item.badge && !item.comingSoon && (
          <span className="absolute top-3 left-3 flex items-center gap-1 bg-gold text-black text-[11px] font-bold uppercase px-2.5 py-1 rounded-full">
            <Star size={11} className="fill-black" /> {item.badge}
          </span>
        )}
      </div>

      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-display text-lg uppercase text-white leading-tight">{item.name}</h3>
        <p className="text-white/55 text-xs mt-1 line-clamp-2 flex-1">{item.desc}</p>

        <div className="mt-3 flex items-center justify-between gap-2">
          <div className="min-w-0">
            {item.seul != null && item.menu != null ? (
              <div className="leading-tight">
                <div className="flex items-baseline gap-1">
                  <span className="text-white font-bold text-sm">{fmt(item.seul)}</span>
                  <span className="text-[9px] text-white/40 uppercase">seul</span>
                </div>
                <div className="flex items-baseline gap-1">
                  <span className="text-gold font-bold text-sm">{fmt(item.menu)}</span>
                  <span className="text-[9px] text-white/40 uppercase">menu</span>
                </div>
              </div>
            ) : (
              <span className="text-gold font-bold text-lg">{fmt(from)}</span>
            )}
          </div>
          <button
            onClick={() => onAdd(item)}
            className="bg-pink text-white rounded-full h-10 px-3 btn-shine shrink-0 flex items-center gap-1 font-semibold"
            aria-label={`Ajouter ${item.name}`}
          >
            <Plus size={18} strokeWidth={2.5} />
            <span className="text-sm">Ajouter</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MenuItemCard;
